import { render, staticRenderFns } from "./huay-list.vue?vue&type=template&id=1e352f8b&scoped=true&"
import script from "./huay-list.vue?vue&type=script&lang=js&"
export * from "./huay-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e352f8b",
  null
  
)

export default component.exports